import { PaymentStatus } from "@bca-confirmation/models/_enums";
import { ITransaction } from "@bca-confirmation/models/transaction";
import { ConfirmationActionTypes } from "@bca-confirmation/store/confirmation.actions";
import * as confirmationActions from "@bca-confirmation/store/confirmation.actions";

export const INITIAL_STATE: IState = {
  transaction: null,
  startPaymentLoading: false,
  statusPaymentLoading: false,
  redirectToIssuerLoading: false,
  paymentFailed: false,
  purchaseEventSent: false,
};

export interface IState {
  readonly transaction: ITransaction;
  readonly startPaymentLoading: boolean;
  readonly statusPaymentLoading: boolean;
  readonly redirectToIssuerLoading: boolean;
  readonly paymentFailed: boolean;
  readonly purchaseEventSent: boolean;
}

export function reducer(
  state: IState = INITIAL_STATE,
  action: confirmationActions.Action,
): IState {
  switch (action.type) {
    case ConfirmationActionTypes.SetReferenceNumber: {
      const { referenceNumber } = action.payload;
      const transaction = { ...state.transaction, referenceNumber };
      return {
        ...state,
        transaction,
      };
    }
    case ConfirmationActionTypes.SetTransaction: {
      const transaction = action.payload;
      const paymentFailed =
        transaction != null &&
        (transaction.paymentStatus === PaymentStatus.Cancelled ||
          transaction.paymentStatus === PaymentStatus.Expired ||
          transaction.paymentStatus === PaymentStatus.Failure ||
          transaction.paymentStatus === PaymentStatus.Unknown);
      return {
        ...state,
        transaction,
        paymentFailed,
      };
    }
    case ConfirmationActionTypes.StartPaymentLoading: {
      const { loading: startPaymentLoading } = action.payload;
      return {
        ...state,
        startPaymentLoading,
      };
    }
    case ConfirmationActionTypes.StatusPaymentLoading: {
      const { loading: statusPaymentLoading } = action.payload;
      return {
        ...state,
        statusPaymentLoading,
      };
    }
    case ConfirmationActionTypes.RedirectToIssuerLoading: {
      const { loading: redirectToIssuerLoading } = action.payload;
      return {
        ...state,
        redirectToIssuerLoading,
      };
    }
    case ConfirmationActionTypes.SetPaymentStatus: {
      const { status: paymentStatus } = action.payload;
      const transaction = { ...state.transaction, paymentStatus };
      const paymentFailed =
        paymentStatus === PaymentStatus.Cancelled ||
        paymentStatus === PaymentStatus.Expired ||
        paymentStatus === PaymentStatus.Failure ||
        paymentStatus === PaymentStatus.Unknown;

      return {
        ...state,
        transaction,
        paymentFailed,
      };
    }
    case ConfirmationActionTypes.SetPurchaseEventSent: {
      return {
        ...state,
        purchaseEventSent: action.payload.avoCapiPurchaseEvent,
      };
    }
  }

  return state;
}
